import {
	PROJECT_INSTANCE,
	PROJECT_REQUEST,
	PROJECT_CLEAR,
	PROJECT_FAIL,
	PROJECT_OWNER,
	PROJECT_EXPENSES_REQUEST,
	PROJECT_EXPENSES_FAIL,
	PROJECT_EXPENSES_CLEAR,
	PROJECT_EXPENSES,
	PROJECT_EMPLOYEES,
	PROJECT_CONCLUSION,
	PROJECT_EMPLOYEES_REQUEST,
	PROJECT_EMPLOYEES_EDIT_REQUEST,
	PROJECT_EMPLOYEES_FAIL,
	PROJECT_OWNER_REQUEST,
	PROJECT_OWNER_FAIL,
	PROJECT_CONCLUSION_REQUEST,
	PROJECT_CONCLUSION_FAIL,
	PROJECT_INSTANCE_REQUEST,
	PROJECT_INSTANCE_LOADED,
	PROJECT_CONCLUSION_CLEAR,
	PROJECT_INSTANCE_FAIL,
	PROJECT_REGISTRY_REQUEST,
	PROJECT_REGISTRY_FAIL,
	PROJECT_OWNER_CLEAR,
	PROJECT_INSTANCE_CLEAR,
	PROJECT_REGISTRY_CLEAR,
	PROJECT_LOADED,
	PROJECT_EMPLOYEES_CLEAR,
	PROJECT_REGISTRY_DATA_REQUEST,
	PROJECT_REGISTRY_DATA_FAIL,
	PROJECT_REGISTRY_DATA,
	PROJECT_REGISTRY_LOADED,
	PROJECT_PROIGUALDAD_GOALS_REQUEST,
	PROJECT_PROIGUALDAD_GOALS_COMPLETE,
	PROJECT_PROIGUALDAD_GOALS,
	PROJECT_PROIGUALDAD_GOALS_EDIT,
	PROJECT_PROIGUALDAD_GOALS_CLEAR,
	PROJECT_PROIGUALDAD_GOALS_FAIL,
	/*PROJECT_AGREEMENTS_ADMIN,
	PROJECT_AGREEMENTS_LEGAL,
	PROJECT_AGREEMENTS_REQUEST,
	PROJECT_AGREEMENTS_ADMIN_REQUEST,
	PROJECT_AGREEMENTS_LEGAL_REQUEST,
	PROJECT_AGREEMENTS_CLEAR,
	PROJECT_AGREEMENTS_FAIL,
	PROJECT_AGREEMENTS_ADMIN_FAIL,
	PROJECT_AGREEMENTS_LEGAL_FAIL,
	PROJECT_AGREEMENTS_LOADED,
	PROJECT_DISPERSIONS,
	PROJECT_DISPERSIONS_REQUEST,
	PROJECT_DISPERSIONS_LOADED,
	PROJECT_DISPERSIONS_CLEAR,
	PROJECT_DISPERSIONS_FAIL,*/
	PROJECT_CONCLUSION_LOADED
} from "../store/config";

const projectInit = {
	isFetching: false,
	owner: {
		isFetching: false,
		editable: false,
		data: {},
		revision: {},
		documents_items: []
	},
	instance: {
		isFetching: false,
		editable: false,
		data: {},
		list: [],
		revision: {},
		documents_items: []
	},
	registry: {
		isFetching: false,
		editable: false,
		data: {
			isFetching: false,
			error: undefined,
			project_goals: [],
			amounts: {}
		},
		revision: {},
		revisions: [],
		documents_items: []
	},
	goals: {
		isFetching: false,
		editable: false,
		list: [],
		pages: {
			current: undefined,
			per_page: undefined,
			total: undefined
		},
		edit: {}
	},
	expenses: {
		isFetching: false,
		editable: false,
		edit: {},
		data: {},
		revision: {},
	},
	profiles: {
		isFetching: false,
		editable: false,
		data: {
			employees: [],
			roles: [],
		},
		edit: {
			isFetching: false
		},
		revision: {},
	},
	conclusion: {
		isFetching: false,
		finished: false,
		editable: false,
		data: {},
		revision: {},
		documents_items: [],
		version: {},
	},
	agreements: {
		isFetching: false,
		admin: {
			isFetching: false,
			data: {}
		},
		legal: {
			isFetching: false,
			data: {}
		}
	},
	dispersions: {
		isFetching: false,
		list: [],
		data: [],
		budgets: {},
		permissions: {}
	},
	phase: {},
	version: {},
	//activity:{},
	permissions: [],
	error: undefined,
	timestamp: undefined
}

const project = (state = projectInit, action) => {
	switch (action.type) {
		case PROJECT_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECT_CLEAR:
			return {
				...state,
				...action.payload,
				timestamp: action.timestamp
			}
		case PROJECT_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		case PROJECT_LOADED:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECT_OWNER:
			return {
				...state,
				owner: {
					...state.owner,
					isFetching: action.isFetching,
					editable: action.editable,
					data: action.payload,
					revision: action.revision,
					documents_items: action.documents_items,
					timestamp: action.timestamp
				},
				phase: action.phase,
				version: action.version,
				permissions: action.permissions
			}
		case PROJECT_OWNER_REQUEST:
			return {
				...state,
				owner: {
					...state.owner,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_OWNER_FAIL:
			return {
				...state,
				owner: {
					...state.owner,
					isFetching: action.isFetching,
					error: action.error
				},
				timestamp: action.timestamp
			}
		case PROJECT_OWNER_CLEAR:
			return {
				...state,
				owner: {
					...state.owner,
					data: action.payload,
					timestamp: action.timestamp
				},
				phase: action.payload
			}
		case PROJECT_INSTANCE:
			return {
				...state,
				instance: {
					...state.instance,
					isFetching: action.isFetching,
					editable: action.editable,
					data: action.payload,
					revision: action.revision,
					documents_items: action.documents_items,
					timestamp: action.timestamp
				},
				phase: action.phase,
				version: action.version,
				permissions: action.permissions,
			}
		case PROJECT_INSTANCE_REQUEST:
			return {
				...state,
				instance: {
					...state.instance,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_INSTANCE_LOADED:
			return {
				...state,
				instance: {
					...state.instance,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_INSTANCE_FAIL:
			return {
				...state,
				instance: {
					...state.instance,
					isFetching: action.isFetching
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case PROJECT_INSTANCE_CLEAR:
			return {
				...state,
				instance: {
					...state.instance,
					data: action.payload
				},
				phase: action.payload,
				timestamp: action.timestamp
			}
		case PROJECT_REGISTRY_LOADED:
			return {
				...state,
				registry: {
					...state.registry,
					isFetching: action.isFetching,
					complete: action.payload
				},
				timestamp: action.timestamp
			}
		case PROJECT_REGISTRY_REQUEST:
			return {
				...state,
				registry: {
					...state.registry,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_REGISTRY_FAIL:
			return {
				...state,
				registry: {
					...state.registry,
					isFetching: action.isFetching
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case PROJECT_REGISTRY_CLEAR:
			return {
				...state,
				registry: {
					...state.registry,
					data: action.payload
				},
				phase: action.payload,
				timestamp: action.timestamp
			}
		case PROJECT_REGISTRY_DATA_REQUEST:
			return {
				...state,
				registry: {
					...state.registry,
					data: {
						...state.registry.data,
						isFetching: action.isFetching
					}
				},
				timestamp: action.timestamp
			}
		case PROJECT_REGISTRY_DATA_FAIL:
			return {
				...state,
				registry: {
					...state.registry,
					data: {
						...state.registry.data,
						isFetching: action.isFetching
					}
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case PROJECT_REGISTRY_DATA:
			return {
				...state,
				registry: {
					...state.registry,
					editable: action.editable,
					data: {
						...state.registry.data,
						isFetching: action.isFetching,
						...action.payload
					},
					revision: action.revision,
					revisions: action.revisions,
					documents_items: action.documents_items
				},
				phase: action.phase,
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECT_PROIGUALDAD_GOALS_REQUEST:
			return {
				...state,
				goals: {
					...state.goals,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_PROIGUALDAD_GOALS_COMPLETE:
			return {
				...state,
				goals: {
					...state.goals,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_PROIGUALDAD_GOALS:
			return {
				...state,
				goals: {
					...state.goals,
					isFetching: action.isFetching,
					list: action.payload,
					pages: action.pages
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECT_PROIGUALDAD_GOALS_EDIT:
			return {
				...state,
				goals: {
					...state.goals,
					isFetching: action.isFetching,
					edit: action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECT_PROIGUALDAD_GOALS_CLEAR:
			return {
				...state,
				goals: {
					...state.goals,
					edit: action.payload
				},
				timestamp: action.timestamp
			}
		case PROJECT_PROIGUALDAD_GOALS_FAIL:
			return {
				...state,
				goals: {
					...state.goals,
					isFetching: action.isFetching,
					error: action.error
				},
				timestamp: action.timestamp
			}
		case PROJECT_EXPENSES_REQUEST:
			return {
				...state,
				expenses: {
					...state.expenses,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_EXPENSES_FAIL:
			return {
				...state,
				expenses: {
					...state.expenses,
					isFetching: action.isFetching,
				},
				error: action.error,
				timestamp: action.timestamp
			}
		case PROJECT_EXPENSES_CLEAR:
			return {
				...state,
				expenses: {
					...state.expenses,
					edit: action.payload,
					data: action.payload
				},
				phase: action.payload,
				timestamp: action.timestamp
			}
		case PROJECT_EXPENSES:
			return {
				...state,
				expenses: {
					...state.expenses,
					isFetching: action.isFetching,
					editable: action.editable,
					data: action.payload,
					revision: action.revision,
				},
				phase: action.phase,
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECT_EMPLOYEES:
			return {
				...state,
				profiles: {
					...state.profiles,
					isFetching: action.isFetching,
					editable: action.editable,
					data: {
						...state.profiles.data,
						...action.payload
					},
					edit: {
						...state.profiles.edit,
						isFetching: action.isFetching,
					},
					revision: action.revision,
				},
				phase: action.phase,
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECT_EMPLOYEES_REQUEST:
			return {
				...state,
				profiles: {
					...state.profiles,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_EMPLOYEES_EDIT_REQUEST:
			return {
				...state,
				profiles: {
					...state.profiles,
					edit: {
						...state.profiles.edit,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case PROJECT_EMPLOYEES_FAIL:
			return {
				...state,
				profiles: {
					...state.profiles,
					isFetching: action.isFetching,
					edit: {
						...state.profiles.edit,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case PROJECT_EMPLOYEES_CLEAR:
			return {
				...state,
				profiles: {
					...state.profiles,
					...action.payload,
				},
				phase: action.phase,
				timestamp: action.timestamp
			}
		case PROJECT_CONCLUSION:
			return {
				...state,
				conclusion: {
					...state.conclusion,
					isFetching: action.isFetching,
					editable: action.editable,
					finished: action.payload.finished,
					data: {
						...state.conclusion.data,
						...action.payload
					},
					revision: action.revision,
					documents_items: action.documents_items
				},
				phase: action.phase,
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECT_CONCLUSION_CLEAR:
			return {
				...state,
				conclusion: {
					...state.conclusion,
					...action.payload,
				},
				phase: action.phase,
				timestamp: action.timestamp
			}
		case PROJECT_CONCLUSION_REQUEST:
			return {
				...state,
				conclusion: {
					...state.conclusion,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_CONCLUSION_LOADED:
			return {
				...state,
				conclusion: {
					...state.conclusion,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECT_CONCLUSION_FAIL:
			return {
				...state,
				conclusion: {
					...state.conclusion,
					isFetching: action.isFetching,
					error: action.error
				},
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
	//deepFreeze(project);
}


export default project;



// WEBPACK FOOTER //
// ./src/reducers/project.js